import type { DiningAvailabilityTimeslot, DiningPromotion } from './schemas';

export type DescribedPromotion = {
  available: DiningAvailabilityTimeslot['availablePromotions'][number];
  promotion: DiningPromotion;
};

export function describedPromotions(
  slot: DiningAvailabilityTimeslot,
  promotions: DiningPromotion[]
): DescribedPromotion[] {
  return slot.availablePromotions.flatMap((available) => {
    const promotion = promotions.find((entry) => entry.id === available.id);
    return promotion ? [{ available, promotion }] : [];
  });
}

export function isBookableSlot(
  slot: DiningAvailabilityTimeslot,
  promotions: DiningPromotion[]
): boolean {
  return slot.hasStandardAvailability || describedPromotions(slot, promotions).length > 0;
}
